;(function (angular, _, moment) {
  'use strict'

  angular
    .module('kilo.routes.inbox.show', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  function RouteConfigurator ($stateProvider) {
    var showState = {
      name: 'inbox.show',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}',
      resolve: {
        inmail: ['$stateParams', 'InmailManager', function ($stateParams, InmailManager) {
          return InmailManager.findById($stateParams.id)
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/inbox/show/templates/inbox-show.template.html',
          controller: 'InboxShowController',
          controllerAs: 'show'
        },
        'toolbar@': {
          controller: 'InboxShowToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: '{{::toolbar.title | truncate: 50}}',
        parent: 'inbox.list'
      }
    }

    $stateProvider
      .state(showState)
  }
})(window.angular, window._, window.moment)
